import { RouteConfig } from 'vue-router'

import {
  ReportAsistance,
  ReportAfp,
  ReportPlame,
  ReportInternalAssistance,
  PaymentSlips,
  Boletas,
  Telecredito,
  Faltas,
  Historico,
  Cts,
  Gratificacion,
  Lbs,
  Utilidades,
  Renta,
  Contabilidad
} from '@/views'

const reportRouter: Array<RouteConfig> = [
	{
    path: '/report-asistance',
    name: 'report-asistance',
    component: ReportAsistance,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de Asistencia'
    }
  },
  {
    path: '/report-afp',
    name: 'report-afp',
    component: ReportAfp,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte AFP'
    }
  },
  {
    path: '/report-plame',
    name: 'report-plame',
    component: ReportPlame,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte Plame'
    }
  },
  {
    path: '/report-internal-assistance',
    name: 'report-internal-assistance',
    component: ReportInternalAssistance,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte Asistencia Interna'
    }
  },
  {
    path: '/payment-slips',
    name: 'payment-slips',
    component: PaymentSlips,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Boletas de pagos'
    }
  },
  {
    path: '/telecreditos',
    name: 'telecreditos',
    component: Telecredito,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte Telecrédito'
    }
  },
  {
    path: '/faltas',
    name: 'faltas',
    component: Faltas,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de Faltas'
    }
  },
  {
    path: '/historico',
    name: 'historico',
    component: Historico,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte Histórico'
    }
  },
  {
    path: '/cts',
    name: 'cts',
    component: Cts,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de Cts'
    }
  },
  {
    path: '/gratificacion',
    name: 'gratificacion',
    component: Gratificacion,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de Gratificaciones'
    }
  },
  {
    path: '/lbs',
    name: 'lbs',
    component: Lbs,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de LBS'
    }
  },
  {
    path: '/utilidades',
    name: 'utilidades',
    component: Utilidades,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de Utilidades'
    }
  },
  {
    path: '/renta',
    name: 'renta',
    component: Renta,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte Renta de 5ta'
    }
  },
  {
    path: '/contabilidad',
    name: 'contabilidad',
    component: Contabilidad,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Reporte de Contabilidad'
    }
  },
  {
    path: '/boletas',
    name: 'boletas',
    component: Boletas,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Boletas mensuales'
    }
  }
]

export default reportRouter
